import {useQuery} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {QUERY_KEYS} from '@/queryClient'
import {DeletionAccountUser, httpGetDeletionUser} from './accountDeletion.http'

/**
 * Resolves the current user's identity from the on-the-fly token.
 * `retry: false` so an invalid/expired token surfaces the error state quickly
 * instead of retrying.
 */
export const useDeletionAccountUser = (token: string | null) =>
    useQuery({
        queryKey: [QUERY_KEYS.ACCOUNT_DELETION_USER, token],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetDeletionUser(token as string),
                responseShape: DeletionAccountUser,
                onZodError: captureException
            }),
        enabled: !!token,
        retry: false,
        staleTime: 0
    })
